import React from 'react';
import { Phone, MessageCircle, Calendar, MapPin, ShoppingCart } from 'lucide-react';

const actions = [
  { icon: <Phone size={16} />, label: 'Call', href: 'tel:+256772206129', track: 'call_click' },
  { icon: <MessageCircle size={16} />, label: 'WhatsApp', href: 'https://wa.me/256772206129', track: 'whatsapp_click' },
  { icon: <Calendar size={16} />, label: 'Reserve', href: '/booking', track: 'reserve_click' },
  { icon: <MapPin size={16} />, label: 'Directions', href: 'https://maps.google.com/?q=Seguku+Entebbe+Road+Uganda', track: 'directions_click' },
  { icon: <ShoppingCart size={16} />, label: 'Order', href: '/menu', track: 'order_click' },
];

const HeroQuickActions = () => (
  <section style={{ backgroundColor: '#1A1A1A', padding: '16px 0' }}>
    <div className="container">
      <div className="hero-quick-actions">
        {actions.map((a, i) => (
          <a key={i} href={a.href} target={a.href.startsWith('http') ? '_blank' : undefined}
             rel={a.href.startsWith('http') ? 'noopener noreferrer' : undefined}
             data-track={a.track}>
            {a.icon}
            <span>{a.label}</span>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default HeroQuickActions;
